import { render, staticRenderFns } from "./ProfileRight.vue?vue&type=template&id=33f2e3ff&scoped=true"
import script from "./ProfileRight.vue?vue&type=script&lang=ts"
export * from "./ProfileRight.vue?vue&type=script&lang=ts"
import style0 from "./ProfileRight.vue?vue&type=style&index=0&id=33f2e3ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f2e3ff",
  null
  
)

export default component.exports